import React, { useState } from 'react';
import { RefreshCw, CheckCircle2, Loader2, AlertCircle } from 'lucide-react';
import { Panel, RowButton, PageHeading } from '../ui';
type SyncState = 'synced' | 'syncing' | 'error';
interface SyncRow {
  umbrella: string;
  activities: number;
  langs: string;
  state: SyncState;
  when: string;
}
const ROWS: SyncRow[] = [{
  umbrella: 'Self',
  activities: 42,
  langs: 'en · hi · mr',
  state: 'synced',
  when: '2 min ago'
}, {
  umbrella: 'Society',
  activities: 38,
  langs: 'en · hi · mr',
  state: 'synced',
  when: '2 min ago'
}, {
  umbrella: 'Ecology',
  activities: 51,
  langs: 'en · hi',
  state: 'error',
  when: 'mr missing'
}];
export function ContentSync() {
  const [rows, setRows] = useState(ROWS);
  const [syncing, setSyncing] = useState(false);
  const runSync = () => {
    setSyncing(true);
    setRows(r => r.map(x => ({
      ...x,
      state: 'syncing' as SyncState
    })));
    setTimeout(() => {
      setRows(r => r.map(x => ({
        ...x,
        state: 'synced',
        langs: 'en · hi · mr',
        when: 'just now'
      })));
      setSyncing(false);
    }, 1800);
  };
  return <div data-id="element-415" data-mp="nyhe5iprp2x8">
      <PageHeading title="Content Sync Status" subtitle="Parent curriculum activities pulled on demand. All text fields must be present in English, Hindi and Marathi." data-id="element-416" data-mp="ny93lxh4a9p7" />
      <Panel title="Curriculum sync" icon={<RefreshCw className="h-4 w-4 text-[#1e2a5a]" data-id="element-418" data-mp="f6p5ndkb03va" />} action={<RowButton variant="read" onClick={runSync} data-id="element-419" data-mp="12wta1n5bg7nc">
            <span className="flex items-center gap-1" data-id="element-420" data-mp="12tx8zpy692uo">
              <RefreshCw className={`h-3.5 w-3.5 ${syncing ? 'animate-spin' : ''}`} data-id="element-421" data-mp="16w264yntwhm2" />
              Sync now
            </span>
          </RowButton>} data-id="element-417" data-mp="f5xmj27w7ylw">
        <table className="w-full text-sm" data-id="element-422" data-mp="xvdpdw71w35h">
          <thead data-id="element-423" data-mp="xyi1rguo6578">
            <tr className="border-b border-slate-200 text-left text-slate-600" data-id="element-424" data-mp="3do2vfqjis83d">
              <th className="px-5 py-3 font-semibold" data-id="element-425" data-mp="3dq5t8wqwz5in">Umbrella</th>
              <th className="px-5 py-3 font-semibold" data-id="element-426" data-mp="3ioh5fe4ols41">Activities</th>
              <th className="px-5 py-3 font-semibold" data-id="element-427" data-mp="2yl1gx26fsfd8">Languages</th>
              <th className="px-5 py-3 font-semibold" data-id="element-428" data-mp="2uj6f7wklfzyx">Status</th>
              <th className="px-5 py-3 font-semibold" data-id="element-429" data-mp="2ujzqnauhzdne">Last sync</th>
            </tr>
          </thead>
          <tbody data-id="element-430" data-mp="2pqn4d7dajixt">
            {rows.map(r => <tr key={r.umbrella} className="border-b border-slate-100 last:border-0" data-id="element-431" data-mp="2ktwp2m9b8rdg">
                <td className="px-5 py-3.5 font-medium text-slate-800" data-id="element-432" data-mp="2fu1zqn56o9ui">
                  {r.umbrella}
                </td>
                <td className="px-5 py-3.5 text-slate-600" data-id="element-433" data-mp="2au5t0g53q4b9">{r.activities}</td>
                <td className="px-5 py-3.5 font-mono text-xs text-slate-500" data-id="element-434" data-mp="26t3r1rjsve5l">
                  {r.langs}
                </td>
                <td className="px-5 py-3.5" data-id="element-435" data-mp="21vkaum3jkrb0">
                  <StateBadge state={r.state} data-id="element-436" data-mp="21wviix03yj7e" />
                </td>
                <td className="px-5 py-3.5 text-slate-500" data-id="element-437" data-mp="51qp9bd4pmdr">{r.when}</td>
              </tr>)}
          </tbody>
        </table>
      </Panel>
    </div>;
}
function StateBadge({
  state
}: {
  state: SyncState;
}) {
  if (state === 'syncing') return <span className="inline-flex items-center gap-1.5 rounded-full bg-sky-100 px-2.5 py-0.5 text-xs font-semibold text-sky-700" data-id="element-438" data-mp="cl88enmgoa9s">
        <Loader2 className="h-3.5 w-3.5 animate-spin" data-id="element-439" data-mp="hd041ckh566s" /> Syncing
      </span>;
  if (state === 'error') return <span className="inline-flex items-center gap-1.5 rounded-full bg-rose-100 px-2.5 py-0.5 text-xs font-semibold text-rose-700" data-id="element-440" data-mp="mdnsprl8daxu">
        <AlertCircle className="h-3.5 w-3.5" data-id="element-441" data-mp="3ps1lu7pww3tc" /> Missing lang
      </span>;
  return <span className="inline-flex items-center gap-1.5 rounded-full bg-emerald-100 px-2.5 py-0.5 text-xs font-semibold text-emerald-700" data-id="element-442" data-mp="3urebf0863ozm">
      <CheckCircle2 className="h-3.5 w-3.5" data-id="element-443" data-mp="2on464i9n370" /> Synced
    </span>;
}